<template>
  <v-row>
    <v-card elevation="0" outlined="">
      <v-card-title class="text-h3">
        <v-icon large="" color="#333">mdi-account</v-icon>
        Cidadão
      </v-card-title>
      <v-card-text>
        <div>
          <v-row>
            <v-col  cols="12" sm="12" md="12">
              <v-card outlined="" elevation="0" class="pa-md-4 mx-lg-auto">
                <v-card-title class="text-h4">
                  Dados do Encaminhamento
                </v-card-title>
                <v-card-text class="text--primary">
                  <p>Situação: {{ (this.testTextHasValue(citizen.descricaoStatusEncaminhamento)) ? citizen.descricaoStatusEncaminhamento : "Não processado" }}</p>
                  
                  <p v-if="showInformationSAS">Tipologia: {{ tipoServico }}<br/>
                     Nome do serviço: {{ nomeServico }} <br>
                     Endereço: {{ endereco }} <span v-if="this.testTextHasValue(complemento)"> - Complemento: {{ complemento }}</span>
                  </p>

                  <p v-if="showInformationSAS">Distrito: {{ descricaoDistrito }} <br>
                      SAS: {{ descricaoSAS }} <br>
                      <span class="text-caption font-italic" v-show="showLocalSigiloso">Entrar em contato com o seu Centro de Referência ou com CPAS para determinar a localização do serviço.</span></p>

                  <p v-if="showInfoCancelamento">Data cancelamento: {{ dataExclusaoEncaminhamento }}<br>
                    Motivo: {{ dcMotivoExclusaoEncaminhamento }}<br>
                    Justificativa: {{ justificativaExclusaoEncaminhamento }}</p>
                  
                  <p v-if="showInfoDecurso">Data decurso de prazo: {{ dataDecursoPrazo }}</p>

                  <p v-if="showInfoConcluido">Data vinculação: {{ dataVinculacao }}</p>
                  <p v-if="showInfoConcluidoPernoite"><span class="font-weight-bold">Data pernoite: </span>{{ dataPernoite }}</p>

                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card outlined="" elevation="0" class="pa-md-4 mx-lg-auto">
                <v-card-title class="text-h4">
                  Identificação
                </v-card-title>
                <v-card-text class="text--primary">
                  <p>Nome: {{ citizen.nome }}</p>
                  <p v-if="this.testTextHasValue(citizen.citizenSISA)">Código SISA: {{ citizen.citizenSISA }}</p>
                  <p>Nome social: {{ citizen.nomeSocial }}</p>
                  <p>Nome da mãe: {{ citizen.nomeMae }}</p>
                  <p>Data de nascimento: {{ citizen.dataNascimento | formatDate_BR() }}</p>
                  <p>É Gestante?&nbsp;&nbsp;<span :class="(citizen.indicadorGestante == 1)? 'blue--text' : 'red--text'">{{ (citizen.indicadorGestante)? 'Sim' : 'Não' }}</span></p>
                  <p v-if="this.testTextHasValue(citizen.descricaoGrauDependencia)">Grau de Dependência: {{ citizen.descricaoGrauDependencia }}</p>
                  <p>Gênero: {{ citizen.descricaoTipoSexo }}</p>
                  <p>Identidade de gênero: {{ citizen.descricaoIdentidadeSexual }}</p>
                  <p>Raça/Cor: {{ citizen.descricaoRaca }}</p>
                  <p>Nacionalidade: {{ citizen.descricaoTipoNacionalidade }} 
                    - País: {{ citizen.documentoIdentidadeEstrangeiro.nomePaisOrigem }}
                    <span v-if="this.testTextHasValue(citizen.documentoIdentidadeEstrangeiro.numeroRNE)"> - RNE: {{ citizen.documentoIdentidadeEstrangeiro.numeroRNE }}</span> 
                    <span v-if="this.testTextHasValue(citizen.documentoIdentidadeEstrangeiro.numeroPassaporte)"> - Passaporte: {{ citizen.documentoIdentidadeEstrangeiro.numeroPassaporte }}</span> 
                  </p>
                  <p v-if="this.testTextHasValue(citizen.numeroCPF)">CPF: {{ this.formatCPFNumber(citizen.numeroCPF) }}</p>
                  <p v-if="this.testTextHasValue(citizen.documentoIdentidade.numero)">RG: {{ citizen.documentoIdentidade.numero }}
                    <span v-if="this.testTextHasValue(citizen.documentoIdentidade.digito)">-{{ citizen.documentoIdentidade.digito }}</span>
                    <span v-if="this.testTextHasValue(citizen.documentoIdentidade.orgaoEmissor)"> - Orgão emissor: {{ citizen.documentoIdentidade.orgaoEmissor }}</span>
                      <span v-if="this.testTextHasValue(citizen.documentoIdentidade.uf)"> / {{ citizen.documentoIdentidade.uf }}</span>
                      <span v-if="this.testTextHasValue(citizen.documentoIdentidade.dataEmissao)"> - Data de emissão: {{ citizen.documentoIdentidade.dataEmissao | formatDate_BR() }}</span>
                  </p>
                  <div v-if="citizen.tipoCertidao == 'A'">
                      <div v-if="this.testTextHasValue(citizen.certidaoNascimento.numero)">
                        <p>
                            Certidão de Nascimento: {{ citizen.certidaoNascimento.numero }}
                            <span v-if="this.testTextHasValue(citizen.certidaoNascimento.livro)"> - Livro: {{ citizen.certidaoNascimento.livro }}</span>
                            <span v-if="this.testTextHasValue(citizen.certidaoNascimento.folha)"> - Folha(as): {{ citizen.certidaoNascimento.folha }}</span>
                            <span v-if="this.testTextHasValue(citizen.certidaoNascimento.nomeCidade)"> - Cidade: {{ citizen.certidaoNascimento.nomeCidade }} / {{ citizen.certidaoNascimento.uf }}</span>
                        </p>
                      </div>
                  </div>
                  <div v-else>
                      <div v-if="this.testTextHasValue(citizen.certidaoNascimento.numeroNovo)">
                        <p>Certidão de Nascimento: {{ citizen.certidaoNascimento.numeroNovo }}</p>
                      </div>
                  </div>
              </v-card-text>
              </v-card>
            </v-col>
            <v-col  cols="12" sm="12" md="12">
              <v-card outlined="" elevation="0" class="pa-md-4 mx-lg-auto">
                <v-card-title class="text-h5 font-weight-bold">
                  Acessibilidade e Autonomia
                </v-card-title>
                <v-card-text class="text--primary">
                  <p>Necessita vaga acessível?&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorVagaAcessivel)? 'blue--text' : 'red--text'">{{ this.isTrueValue(citizen.indicadorVagaAcessivel)? 'Sim' : 'Não' }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorVagaAcessivel) && this.testTextHasValue(citizen.descricaoVagaAcessivel)"><br/>Justificativa:&nbsp;&nbsp;<span>{{ citizen.descricaoVagaAcessivel }}</span></span>
                  </p>
                  <p>Necessita de Cuidados de Terceiros?&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorCuidadoTerceiros)? 'blue--text' : 'red--text'">{{ this.isTrueValue(citizen.indicadorCuidadoTerceiros)? 'Sim' : 'Não' }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorCuidadoTerceiros) && !this.isArrayNullEmpty(citizen.formasCuidado)"><br/>Cuidados necessários:&nbsp;&nbsp;<span>{{ citizen.formasCuidado.map(f => f.descricao).join(', ') }}</span></span>
                  </p>
                  <p>Possui Deficiências?&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorPossuiDeficiencia)? 'blue--text' : 'red--text'">{{ this.isTrueValue(citizen.indicadorPossuiDeficiencia)? 'Sim' : 'Não' }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorPossuiDeficiencia) && !this.isArrayNullEmpty(citizen.deficiencias)"><br/>Deficiência(s):&nbsp;&nbsp;<span>{{ this.getTextoDeficiencia(citizen.deficiencias) }}</span></span>
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col  cols="12" sm="12" md="12">
              <v-card outlined="" elevation="0" class="pa-md-4 mx-lg-auto">
                <v-card-title class="text-h5 font-weight-bold">
                  Acolhimento
                </v-card-title>
                <v-card-text class="text--primary">
                  <p>Já esteve Acolhido?&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorAcolhimentoAnterior)? 'blue--text' : 'red--text'">{{ this.testNullField(citizen.indicadorAcolhimentoAnterior) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorAcolhimentoAnterior) && this.testTextHasValue(citizen.descricaoLocalAcolhimentoAnterior)"><br/>Serviços:&nbsp;&nbsp;<span>{{ citizen.descricaoLocalAcolhimentoAnterior }}</span></span>
                  </p>
                  <p>Possui familiar(es) acolhido(s)?&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorPossuiFamiliarAcolhido)? 'blue--text' : 'red--text'">{{ this.testNullField(citizen.indicadorPossuiFamiliarAcolhido) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorPossuiFamiliarAcolhido) && this.testTextHasValue(citizen.descricaoFamiliarAcolhido)"><br/>Serviços:&nbsp;&nbsp;<span>{{ citizen.descricaoFamiliarAcolhido }}</span></span>
                  </p>
                  <p>Vítima de violência?&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorVitimaViolencia)? 'blue--text' : 'red--text'">{{ this.testNullField(citizen.indicadorVitimaViolencia) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorVitimaViolencia) && citizen.distritos != null && citizen.distritos.length > 0"><br/>Distritos:&nbsp;&nbsp;<span>{{ this.convertDistrictArrayToString(citizen.distritos, 'V') }}</span></span>
                  </p>
                  <p>Está sob ameaça de morte?&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorAmeaca)? 'blue--text' : 'red--text'">{{ this.testNullField(citizen.indicadorAmeaca) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorAmeaca) && citizen.distritos != null && citizen.distritos.length > 0"><br/>Distritos:&nbsp;&nbsp;<span>{{ this.convertDistrictArrayToString(citizen.distritos, 'A') }}</span></span>
                  </p>
                  <p>PPCAAM foi acionado?&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorPPCAAM)? 'blue--text' : 'red--text'">{{ this.testNullField(citizen.indicadorPPCAAM) }}</span>
                  </p>
                  <p v-if="this.isTrueValue(citizen.indicadorVitimaViolencia) || this.isTrueValue(citizen.indicadorAmeaca)">Acolhimento sigilogo?&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorAcolhimentoSigiloso)? 'blue--text' : 'red--text'">{{ this.testNullField(citizen.indicadorAcolhimentoSigiloso) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorAcolhimentoSigiloso) && !this.isArrayNullEmpty(citizen.tiposServicosSolicitados)"><br/>Tipologia:&nbsp;&nbsp;<span>{{ citizen.tiposServicosSolicitados.map(t => t.descricao).join(', ') }}</span></span>
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col  cols="12" sm="12" md="12">
              <v-card outlined="" elevation="0" class="pa-md-4 mx-lg-auto">
                <v-card-title class="text-h5 font-weight-bold">
                    Processos
                </v-card-title>
                <v-card-text class="text--primary">
                  <p>Possui Ordem Judicial?&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorOrdemJudicial)? 'blue--text' : 'red--text'">{{ this.testNullField(citizen.indicadorOrdemJudicial) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorOrdemJudicial) && this.testTextHasValue(citizen.descricaoOrdemJudicial)"><br/>Determinação Judicial:&nbsp;&nbsp;<span>{{ citizen.descricaoOrdemJudicial }}</span></span>
                  </p>
                  <p v-if="(currentAge > 0 && currentAge < 18)">Há processos na Vara da Infância e Juventude?&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorProcessoVIJ)? 'blue--text' : 'red--text'">{{ this.testNullField(citizen.indicadorProcessoVIJ) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorProcessoVIJ) && this.testTextHasValue(citizen.nomeVaraInfanciaJuventude)"><br/>Local:&nbsp;&nbsp;<span>{{ citizen.nomeVaraInfanciaJuventude }}</span></span><span v-if="this.isTrueValue(citizen.indicadorProcessoVIJ) && this.testTextHasValue(citizen.descricaoProcessoVIJ)"> - Processo:&nbsp;&nbsp;<span>{{ citizen.descricaoProcessoVIJ }}</span></span>
                  </p>
                  <p v-if="(currentAge >= 14 && currentAge <= 21)">Há processos no DEIJ?&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorProcessoDEIJ)? 'blue--text' : 'red--text'">{{ this.testNullField(citizen.indicadorProcessoDEIJ) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorProcessoDEIJ) && this.testTextHasValue(citizen.descricaoProcessoDEIJ)"><br/>Processo:&nbsp;&nbsp;<span>{{ citizen.descricaoProcessoDEIJ }}</span></span>
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col  cols="12" sm="12" md="12">
              <v-card outlined="" elevation="0" class="pa-md-4 mx-lg-auto">
                <v-card-title class="text-h5 font-weight-bold">
                    Saúde
                </v-card-title>
                <v-card-text class="text--primary">
                  <p>Utiliza medicação de uso contínuo?&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorMedicacaoContinua)? 'blue--text' : 'red--text'">{{ this.testNullField(citizen.indicadorMedicacaoContinua) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorMedicacaoContinua) && this.testTextHasValue(citizen.descricaoMedicacaoContinua)"><br/>Medicamentos:&nbsp;&nbsp;<span>{{ citizen.descricaoMedicacaoContinua }}</span></span>
                  </p>
                  <p>Realiza acompanhamento em serviço de saúde?&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorFazAcompanhamentoServicoSaude)? 'blue--text' : 'red--text'">{{ this.testNullField(citizen.indicadorFazAcompanhamentoServicoSaude) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorFazAcompanhamentoServicoSaude) && this.testTextHasValue(citizen.descricaoAcompanhamentoServicoSaude)"><br/>Local:&nbsp;&nbsp;<span>{{ citizen.descricaoAcompanhamentoServicoSaude }}</span></span>
                  </p>
                  <p>Realiza acompanhamento no CAPS?&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorAcompanhamentoCAPS)? 'blue--text' : 'red--text'">{{ this.testNullField(citizen.indicadorAcompanhamentoCAPS) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorAcompanhamentoCAPS) && this.testTextHasValue(citizen.descricaoAcompanhamentoCAPS)"><br/>Local:&nbsp;&nbsp;<span>{{ citizen.descricaoAcompanhamentoCAPS }}</span></span>
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col  cols="12" sm="12" md="12">
              <v-card outlined="" elevation="0" class="pa-md-4 mx-lg-auto">
                <v-card-title class="text-h5 font-weight-bold">
                    Informações Adicionais
                </v-card-title>
                <v-card-text class="text--primary">
                  <p>Possui autonomia financeira?&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.possuiAutonomiaFinanceira)? 'blue--text' : 'red--text'">{{ this.testNullField(citizen.possuiAutonomiaFinanceira) }}</span></p>
                  <p>Possui carroça?&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorPossuiCarroca)? 'blue--text' : 'red--text'">{{ this.testNullField(citizen.indicadorPossuiCarroca) }}</span></p>
                  <p>Possui animal de estimação?&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorPossuiAnimalEstimacao)? 'blue--text' : 'red--text'">{{ this.testNullField(citizen.indicadorPossuiAnimalEstimacao) }}</span></p>
                  <p>Está em período de convalescência?&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorConvalescencia)? 'blue--text' : 'red--text'">{{ this.testNullField(citizen.indicadorConvalescencia) }}</span>
                  <span v-if="this.isTrueValue(citizen.indicadorConvalescencia) && this.testTextHasValue(citizen.descricaoPrognostico)"><br/><span>Prognóstico:</span>&nbsp;&nbsp;<span>{{ citizen.descricaoPrognostico }}</span></span>
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
    <snackbar
        :text="snackbarMessage"
        :color="snackbarColor"
    />    
  </v-row>
</template>
<script>
  import moment from 'moment';
  import citizenService from '../../services/citizen.service';
  import snackbarMixin from "@/mixins/snackbar.mixin";

  export default {
  props:[ 'citizen','idSolicitacao' ],
  mixins: [snackbarMixin],
  data(){
    return {
        currentAge:-1,
        descricaoSAS:'',
        descricaoDistrito:'',
        nomeServico:'',
        tipoServico:'',
        justificativaExclusaoEncaminhamento:'',
        dcMotivoExclusaoEncaminhamento:'',
        dataExclusaoEncaminhamento:'',
        dataDecursoPrazo:'',
        dataVinculacao:'',
        dataPernoite:'',
        endereco:'',
        complemento:'',
        inTipoReserva:'',
        showInformationSAS: false,
        showInfoDecurso: false,
        showInfoCancelamento: false,
        showInfoConcluido:false,
        showLocalSigiloso:false,
        showInfoConcluidoPernoite:false,
      }
  },
  methods:{
    testNullField(value){
      if(this.isTrueValue(value))
      return 'Sim';
      else if(value == false || value == "0" || value === 0)
      return 'Não';
      else
      return "Não informado";
    },
    testTinyntField(value){
      if(value == 1)
      return 'Sim';
      else if(value == 0)
      return 'Não';
      else
      return 'Não Informado';
    },
    testTextHasValue(value){
      return (value != null && value.toString().length > 0);
    },
    convertServiceTypeArrayToString(arrServiceType){
      if(arrServiceType == null)
      return '';

      var servicos = arrServiceType.map(function(item){ return item['descricao']});
      return servicos.join(', ');
    },
    convertDisabilityArrayToString(arrDisabilites){
      if(arrDisabilites == null)
      return '';

      var deficiencias = arrDisabilites.map(function(item){ return item['descricao']});
      return deficiencias.join(', ');
    },
    convertDistrictArrayToString(arrDistrict, type){
      if(arrDistrict == null)
        return '';
      
      let listFiltered = arrDistrict.filter(d => d.tipoUso == type);
      if(listFiltered == null)
        return '';
      
      var distritos = listFiltered.map(item => item['descricao']).join(', ');

      return distritos;
    },
    clear(){
      this.citizen = '';
    },
    isTrueValue(value){
        let isTrue = ((value != undefined) && (value == "true" || value == "1" || value == true || value === 1));
        return isTrue;
    }, 
    isArrayNullEmpty(arr){
      let isNull = (arr == null || arr == '' || arr == [] || arr.length == 0);
      return isNull;
    },
    checkNullTF(value){
      if(value == undefined || value == null || value == '')
        return "Não informado";
      else if(this.isTrueValue(value))
        return "Sim";
      else
        return "Não";
    },
    getPresentAge(value){
      let presentDay = moment();
      let birthDate = moment(value);
      let valid = birthDate.isValid();
      if(valid){
        this.currentAge = presentDay.diff(birthDate, 'years');
      }
      else {
        this.currentAge = -1;
      }
    },
    formatCPFNumber(value){
      let cpf = value.toString().replace(/[^\d]/g,'');
      cpf = '00000000000' + cpf;
      cpf = cpf.substring(cpf.length - 11, cpf.length);
      cpf = cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");

      return cpf;
    },
    getInformacaoEncaminhamento(idEncaminhamento,idSolicitacao){
      citizenService.getEncaminhamentoCidadao(idEncaminhamento, parseInt(idSolicitacao))
                .then(result => {
                    if(result.status == 200 && result.data){
                        let r = result.data;
                        if(r) {
                            this.nomeServico = r.nm_servico;
                            this.tipoServico = r.dc_tipo_servico;
                            this.justificativaExclusaoEncaminhamento = r.tx_justificativa_exclusao_encaminhamento;
                            this.dcMotivoExclusaoEncaminhamento = r.dc_motivo_exclusao_encaminhamento;
                            this.descricaoDistrito = r.nomeDistrito;
                            this.descricaoSAS = r.nomeSubprefeitura;
                            this.dataVinculacao = r.dtVinculacao;
                            this.dataDecursoPrazo = r.dtDecursoPrazo;
                            this.dataExclusaoEncaminhamento = r.dtCancelamento;
                            this.endereco = r.dc_endereco;
                            this.complemento = r.dc_complemento_endereco;
                            this.dataPernoite = r.dtPernoite;
                            this.inTipoReserva = r.in_tipo_reserva;
                            
                            this.showObsSigiloso(this.descricaoSAS);
                        }
                    }
                }).catch(error => {
                    this.showSnackbar("Não foi possível efetuar a operação.", 'error');
                    console.log(error);
                });
    },
    showInformations(value){
      
      if(this.testTextHasValue(value))
      {
        this.showInformationSAS = true;
        let indicaPernoite = this.testTextHasValue(this.inTipoReserva);

        if(value =="Cancelado"){
          this.showInfoCancelamento = true;
        } 
        else if(value=="Concluído"){
          if(indicaPernoite=="1"){
            this.showInfoConcluidoPernoite = true;
          } else {
            this.showInfoConcluido = true;
          }
          
        }
        else if(value=="Não Concluído"){
          this.showInfoDecurso = true;
        }
      }
    },
    getTextoDeficiencia(def){
      let textoDeficiencia = [];
      let texto = '';
      if(def != null && def != undefined && def.length > 0){
        for(let i = 0; i < def.length; i++){
          texto = def[i].descricao + ' - Afeta Mobilidade: ' + (this.isTrueValue(def[i].afetaMobilidade) ? "SIM" : "NÃO");
          textoDeficiencia.push(texto);
        }
      }

      return textoDeficiencia.join(', ');
    },    
    showObsSigiloso(value){
      if(value == "SIGILOSO"){
        this.showLocalSigiloso = true;
      }else{
        this.showLocalSigiloso = false;
      }
    }
  },
  mounted(){
    this.showLocalSigiloso = false;
    this.getPresentAge(this.citizen.dataNascimento);
    if(this.citizen.codigoSrvicoHospedagemReservaVaga != null && this.citizen.codigoSrvicoHospedagemReservaVaga != undefined)
      this.getInformacaoEncaminhamento(this.citizen.codigoSrvicoHospedagemReservaVaga,this.idSolicitacao);
    this.showInformations(this.citizen.descricaoStatusEncaminhamento);
 }
  
}
</script>
<style scoped>

</style>